import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaceSkull = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18 31V28",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 31V28",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 22C16.8807 22 18 20.8807 18 19.5C18 18.1193 16.8807 17 15.5 17C14.1193 17 13 18.1193 13 19.5C13 20.8807 14.1193 22 15.5 22Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5 22C25.8807 22 27 20.8807 27 19.5C27 18.1193 25.8807 17 24.5 17C23.1193 17 22 18.1193 22 19.5C22 20.8807 23.1193 22 24.5 22Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 19C30.0024 17.2948 29.5687 15.6174 28.7402 14.127C27.9116 12.6367 26.7158 11.383 25.2662 10.485C23.8167 9.587 22.1616 9.0746 20.4582 8.99647C18.7549 8.91833 17.0598 9.27706 15.5341 10.0386C14.0085 10.8001 12.7028 11.939 11.7414 13.3473C10.7799 14.7555 10.1945 16.3862 10.0407 18.0844C9.887 19.7826 10.1701 21.4919 10.863 23.0499C11.556 24.6079 12.6359 25.9629 14 26.986V30C14 30.2652 14.1054 30.5195 14.2929 30.7071C14.4804 30.8946 14.7348 31 15 31H25C25.2652 31 25.5196 30.8946 25.7071 30.7071C25.8946 30.5195 26 30.2652 26 30V26.986C27.2417 26.0574 28.2497 24.8521 28.9441 23.4658C29.6385 22.0795 30 20.5504 30 19V19Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgFaceSkull);
export default ForwardRef;
